export default __webpack_public_path__ + "static/media/levtours_white_trans_bg.4c27b823.png";